import React from 'react'

export default class IconsDnDText extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
            >
                <path
                    d='M1.3335 10.6668L4.02616 4.20678C4.05148 4.14605 4.09421 4.09417 4.14896 4.05767C4.20371 4.02118 4.26803 4.00171 4.33383 4.00171C4.39963 4.00171 4.46395 4.02118 4.5187 4.05767C4.57345 4.09417 4.61618 4.14605 4.6415 4.20678L7.3335 10.6668'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M14.6665 6V10.6667'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M2.20264 8.66675H6.46397'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M12.3333 10.6667C13.622 10.6667 14.6667 9.622 14.6667 8.33333C14.6667 7.04467 13.622 6 12.3333 6C11.0447 6 10 7.04467 10 8.33333C10 9.622 11.0447 10.6667 12.3333 10.6667Z'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
